<style lang="scss" scoped>
    .search-main {
        padding: 10px 10px 0;
        background-color: #fff;
        border: 1px solid #ddd;
        margin-bottom: 10px;
        border-radius: 8px;
    }
    .search-first-line {
        padding-bottom: 5px;
    }
</style>

<template>
    <div class="search-wrap">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button size='large'  v-for="(item,index) in btnsearch" :key="index" :type="formData.status===item.value?'primary':'default'" @click="handleBtn('status',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="search-first-line clearfix">
                <div class="pull-left">
                    <Button type="primary" @click="handleModal('add')" icon="md-add">{{$t('erp.product.new_add', { defaultValue: '添加' })}}</Button>
                    <Button type="info" @click="handleModal('download')">{{$t('global.common.export', { defaultValue: '导出' })}}</Button>
                </div>
        
                <div class="pull-right">
                    <Form :label-width="60" inline>
                        <FormItem :label="$t('erp.channelbase.channel_type', { defaultValue: '渠道类型' })">
                            <Select clearable v-model="formData['channel_category']" filterable>
                                <Option v-for="item in accountType" :value="item.name" :key="item.key">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem :label="$t('erp.channelbase.channel_name', { defaultValue: '渠道名称' })">
                            <Select clearable v-model="formData['account_id']" filterable>
                                <Option :value="null">{{$t('fbb.alloment.all', { defaultValue: '所有' })}}</Option>
                                <Option v-for="item in getNewAccountIdList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                        <!-- <FormItem label='仓库'>
                            <Select clearable v-model="formData['org_warehouse_id']" filterable>
                                <Option :value="null">所有</Option>
                                <Option v-for="item in warehouses" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label='创建时间'>
                            <DatePicker type="daterange" clearable v-model="formData.created_at"></DatePicker>
                        </FormItem> -->
                        <FormItem :label-width="1">
                            <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search', { defaultValue: '搜索' })}}</Button>
                            <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order', { defaultValue: '重置' })}}</Button>
                            <Button @click="moreSearch" icon='ios-arrow-down'>{{$t('erp.channel.more', { defaultValue: '更多' })}}</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <transition v-if="showMore">
                <Form class="pull-left" :label-width="60" inline>
                    <FormItem :label="$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' })">
                        <Select clearable v-model="formData['org_warehouse_id']" filterable>
                            <Option :value="null">{{$t('fbb.alloment.all', { defaultValue: '所有' })}}</Option>
                            <Option v-for="item in warehouses" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('global.common.createdtime', { defaultValue: '创建时间' })">
                        <DatePicker type="daterange" clearable v-model="formData.created_at"></DatePicker>
                    </FormItem>
                </Form>
            </transition>
        </article>
    </div>
</template>

<script>
import { HttpAccountType } from '@/service/boss/allot';
import { mapState,mapGetters } from 'vuex'


export default {

    data() {
        return {
            accountType: [],
            // isOpen: false,
            
            formData: {
                org_warehouse_id: '',
                account_id: '',
                created_at: '',
                status: 1
            },
            showMore: false,
        };
    },
    created () {
        HttpAccountType().then(res => {
            this.accountType = res.data
        })
    },
    mounted() {
        this.update();
    },
    computed: {
        ...mapGetters('diction',['getNewAccountIdList','getNewWarehouseIdList']),
        warehouses(){
            return this.getNewWarehouseIdList.filter(item => {
                return item.attach.item.warehouseType !== 2 && item.attach.item.warehouseType !== 4;
            });
        },
        btnsearch(){
            return [{
                value: 1,
                label: this.$t('global.common.effective', { defaultValue: '有效' })
            }, {
                value: 0,
                label: this.$t('fbb.accountmanage.loss_effect', { defaultValue: "失效" })
            }, {
                value: null,
                label: this.$t('erp.channel.unsize', { defaultValue: "不限" })
            },]
        },
    },
    methods: {
        moreSearch () {
            this.showMore = !this.showMore
        },
        handleModal(type, id) {
            this.$parent.handleOperate(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update() {
            let formdata = { ...this.formData }, created_at = formdata.created_at, filter = "";
            if (formdata.channel_category) {
                // let channelCategoryArr = formdata.channel_category
                // formdata.channel_category = channelCategoryArr.map(item => {
                //     return `'${item}'`
                // })
                formdata.channel_category = `'${formdata.channel_category}'`
            }
            if (created_at) {
                formdata.created_at = created_at[0] ? this.handleDateFormat(created_at[0]) + ' ~ ' + this.handleDateFormat(created_at[1]) : '';
            }
            Object.keys(formdata).forEach(function (key) {
                const val = this[key];
                if (val !== "" && val !== null && val !== undefined) {
                    filter += key + ":" + val + ",";
                }
            }, formdata);
            filter = filter.slice(0, -1);
            this.$emit('on-update', { filter, page: 1 });
        },
        reset() {
            this.formData = {
                org_warehouse_id: '',
                account_id: '',
                created_at: '',
                channel_category: '',
                status: null
            };
            this.$emit('on-update', { page: 1, filter: "" });
        },

    },
};
</script>
